import { FloorExceptionalClosingHoursResponse} from '@jooxter/api';
import { createContext, useContext } from 'react';

export interface FloorExceptionalClosingHoursFormContextType {
  showFloorExceptionalClosingHours: FloorExceptionalClosingHoursResponse| null;
  showFloorExceptionalClosingHoursDetails: (floorExceptionalClosingHours: FloorExceptionalClosingHoursResponse) => void;
  closeFloorExceptionalClosingHoursDetails: () => void;
}

export const FloorExceptionalClosingHoursFormContext =
  createContext<FloorExceptionalClosingHoursFormContextType | null>(null);

export const useFloorExceptionalClosingHoursFormContext = (): FloorExceptionalClosingHoursFormContextType | null => {
  const context = useContext(FloorExceptionalClosingHoursFormContext);

  return context;
};
